module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/cardsCoins-60993c5c689634512d7a0def4bede926.png";